const templateUrl = require('./validation-messages.html');

module.exports = {
  templateUrl: templateUrl,
  transclude: true,
  bindings: {
    input: '@ogFor'
  },
  require: {
    form: '^form'
  }
};
